import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  Form,
  Row,
  Col,
  InputGroup,
  Card,
  Button,
  Table,
} from "react-bootstrap";
import {
  IconCopyMinus,
  IconGridDots,
  IconInvoice,
  IconSearch,
  IconCoin,
  IconPercentage,
  IconCurrencyDollar,
  IconArrowNarrowRight,
  IconPlus,
  IconTrash,
  IconLock,
  IconLockOpen2,
  IconCopy,
} from "@tabler/icons-react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { useSelector } from "react-redux";
import { useFormContext, useFieldArray, Controller } from "react-hook-form";
import {
  API_ENDPOINTS,
  handleKeyDown,
  roundToMoney,
  trimText,
  truncateFormat,
} from "../../constant/_constant";
import SearchPopUp from "./SearchPopUp";

import useDebounce from "../../hooks/useDebounce";
import usePostRequest from "../../hooks/usePostRequest";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

function OrderDetailsForm({ order_ref_type, isEditing }) {
  const {
    getValues,
    register,
    watch,
    control,
    formState: { errors },
    setValue,
    trigger,
  } = useFormContext();
  // const contractName = useSelector((state) => state.contract.contractName);
  const contractName = watch("contract_name");

  const textareaRef = useRef(null);
  const [dataSuggetion, setDataSuggetion] = useState([]);
  const [height, setHeight] = useState();
  const [shippingHide, setShippingHide] = useState(false);
  const [totalCostBeforeMargin, setTotalCostBeforeMargin] = useState("0.00");
  const [totalCostAfterMargin, setTotalCostAfterMargin] = useState("0.00");
  const [showModal, setShowModal] = useState(false);
  const [showSkuId, setShowSkuId] = useState(false);
  const [vendorWarnings, setVendorWarnings] = useState({}); // New state for vendor warnings
  const [suggestionData, setSuggestionData] = useState([]);
  const [searchProps, setSearchProps] = useState({
    searchSku: "",
    searchDescription: "",
    searchVendor: "",
    indexIs: "",
    ContractName: "",
    project_opportunity: "",
  });

  // const ordertype = watch("ordertype");
  // const vendorPartner = watch("cards");

  const ordertype = watch("ordertype");

  const vendorPartner = ["M", "CRK", "DS", "S"].includes(ordertype)
    ? watch("product_sales")
    : watch("cards");
  // const syncProductSalesWithCards = () => {
  //   const latestCards = getValues('cards') || [];
  //   // console.log("latestCards", latestCards)
  //   if ((ordertype === 'DS' || ordertype === 'M') && latestCards.length > 0) {
  //     const updatedSales = latestCards.map(card => ({
  //       vendorPartner: card.vendorPartner || '',
  //       skuId: card.skuId || '',
  //       skuDescription: card.salesDescription || '',
  //       cost: card.cost || 0,
  //       qty: card.qty || 1,
  //       margin: card.margin ?? 0,
  //       customerCost: card.customerCost || 0,
  //       um: card.um || '',
  //       totalSkuCost: card.totalSkuCost || 0,
  //     }));
  //     setValue('product_sales', updatedSales, { shouldValidate: true });
  //   }
  // };

  useEffect(() => {
    const currentOriginalVendors = getValues("originalVendorsPurchase") || {};
    if (!getValues("originalVendorsPurchase")) {
      setValue("originalVendorsPurchase", {});
    }
  }, [getValues, setValue]);

  const [searchDebounces, setSearchDebounces] = useState({
    searchName: "",
  });

  const { data: vendors, postData: fetchVendors } = usePostRequest(
    API_ENDPOINTS.GET_VENDORS,
  );

    const syncSalesTotalCostWithPurchaseFees = useCallback(() => {
    console.log("syncSalesTotalCostWithPurchaseFees was triggered");
    const salesRows = getValues("product_sales") || [];
    const rawProductTotal = salesRows.reduce(
      (sum, row) =>
        sum + (parseFloat(row.cost) || 0) * (parseFloat(row.qty) || 0),
      0,
    );
    const shipping = parseFloat(getValues("shippingCost")) || 0;
    const tax = parseFloat(getValues("tax")) || 0;
    const otherCostRows = getValues("otherCost") || [];
    const otherTotal = otherCostRows.reduce(
      (sum, c) => sum + (parseFloat(c?.Amount) || 0),
      0,
    );
    setValue(
      "totalCostBeforeMarginSales",
      roundToMoney(rawProductTotal + shipping + tax + otherTotal),
    );
  }, [getValues, setValue]);

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (
        name === "shippingCost" ||
        name === "tax" ||
        /^otherCost\[\d+\]\.Amount$/.test(name || "")
      ) {
        syncSalesTotalCostWithPurchaseFees();
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, syncSalesTotalCostWithPurchaseFees]);

  const { order_id } = useParams();

  console.log("ORIGINAL VENDORS KI LIST", getValues("originalVendorsPurchase"));

  useEffect(() => {
    if (searchDebounces?.searchName?.length > 0) {
      fetchVendors(
        {
          search:
            searchDebounces?.searchName?.length > 0
              ? searchDebounces?.searchName
              : undefined,
        },
        onSuggestionSuccessData,
      );
    }
  }, [searchDebounces]);

  const onSuggestionSuccessData = (data) => {
    setSuggestionData(data);
  };

  const handleSearchByName = (e) => {
    setSearchDebounces({ searchName: e.target.value });
  };

  const handleSelectVendor = (item, index) => {
    const currentVendorPartner = getValues(`cards[${index}].vendorPartner`);
    const originalVendors = getValues("originalVendorsPurchase") || {};
    const originalVendor = originalVendors[index];
    const newVendor = item?.display_name;

    console.log("originalVendor", originalVendor);
    console.log("newVendor", newVendor);
    // Check if this is a change from the original product vendor
    if (originalVendor && originalVendor !== newVendor) {
      setVendorWarnings((prevWarnings) => ({
        ...prevWarnings,
        [index]: true,
      }));
      console.log(`Vendor changed for card ${index}:`, {
        original: originalVendor,
        new: newVendor,
        productSku: getValues(`cards[${index}].skuId`),
      });
    } else {
      setVendorWarnings((prevWarnings) => {
        const updated = { ...prevWarnings };
        delete updated[index];
        return updated;
      });
    }

    setValue(`cards[${index}].vendorPartner`, newVendor, {
      shouldValidate: true,
    });

    // Clear suggestions
    setSuggestionData([]);
    setSearchDebounces({ searchName: "" });
  };

  const project_opportunity_id = watch("ProjectID");
  // console.log("project_opportunity_id", project_opportunity_id)
  const handleOpenModal = (index, type) => {
    if (index === null && type === "skuAll") {
      const currentCards = getValues("cards");
      const blankIndex = currentCards.findIndex(
        (card) => !card.skuId && !card.cost && !card.skuDescription,
      );
      if (blankIndex !== -1) {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          indexIs: blankIndex,
        });
      } else {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          project_opportunity: project_opportunity_id,
          indexIs: undefined,
        });
      }
      // setSearchProps({
      //   searchSku: "",
      //   searchDescription: "",
      //   searchVendor: "",
      // });
    } else if (index === null && type === "contract") {
      const currentCards = getValues("cards");
      const blankIndex = currentCards.findIndex(
        (card) => !card.skuId && !card.cost && !card.skuDescription,
      );
      if (blankIndex !== -1) {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          ContractName: contractName,
          indexIs: blankIndex,
        });
      } else {
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          searchVendor: "",
          ContractName: contractName,
          indexIs: undefined,
        });
      }
      // setSearchProps({
      //   searchSku: "",
      //   searchDescription: "",
      //   searchVendor: "",
      //   ContractName: contractName,
      // });
    } else {
      const { vendor, sku, description } = cardSearch[index];
      setSearchProps({
        searchSku: sku,
        searchDescription: description,
        searchVendor: vendor,
        indexIs: index,
      });
    }
    setShowModal(true);
  };
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const {
    fields: cardFields,
    append: appendCard,
    remove: removeCard,
  } = useFieldArray({
    control,
    name: "cards",
  });
  const {
    fields: otherCostFields,
    append: appendOtherCost,
    remove: removeOtherCost,
  } = useFieldArray({
    control,
    name: "otherCost",
  });

  const handleAddOtherCost = () => {
    appendOtherCost({
      Name: "",
      Amount: "",
    });
  };
  const handleAddCard = () => {
    const newIndex = cardFields.length;
    appendCard({
      vendorPartner: "",
      skuId: "",
      skuDescription: "",
      productName: "",
      qty: 1,
      um: "EA",
      cost: "",
      margin: 0,
      customerCost: "",
      totalSkuCost: "",
    });

    setVendorWarnings((prev) => {
      const updated = { ...prev };
      delete updated[newIndex];
      return updated;
    });
    const currentOriginalVendors = getValues("originalVendorsPurchase") || {};
    setValue("originalVendorsPurchase", {
      ...currentOriginalVendors,
      [newIndex]: undefined,
    });
    calculateCosts();
  };

  const handleAddSku = (product) => {
    const currentValues = getValues("cards") || [];
    const newIndex = currentValues.length;

    // Set the original vendor for the new card
    const currentOriginalVendors = getValues("originalVendorsPurchase") || {};
    setValue("originalVendorsPurchase", {
      ...currentOriginalVendors,
      [newIndex]: product?.Vendor?.display_name,
    });

    // Clear any vendor warning for the new card
    setVendorWarnings((prev) => {
      const updated = { ...prev };
      delete updated[newIndex];
      return updated;
    });
    if (product?.customer_price === "0.00") {
      appendCard({
        vendorPartner: product?.Vendor?.display_name,
        skuId: product?.sku_display_name,
        skuIdUnique: product?.sku_id,
        skuDescription: product?.description,
        purchaseDescription: product?.description_sales,
        productName: product?.name,
        qty: 1,
        um: "EA",
        cost: product?.aspetto_price,
        margin: 8.0,
        // customerCost: (product?.aspetto_price / (1 - 8 / 100)).toFixed(2),
        customerCost: truncateFormat(product?.aspetto_price / (1 - 8 / 100), 2),
        totalSkuCost: product?.aspetto_price,
      });
    } else {
      const margin =
        ((product?.customer_price - product?.aspetto_price) /
          product?.customer_price) *
        100;
      appendCard({
        vendorPartner: product?.Vendor?.display_name,
        skuId: product?.sku_display_name,
        skuIdUnique: product?.sku_id,
        skuDescription: product?.description,
        purchaseDescription: product?.description_sales,
        productName: product?.name,
        qty: 1,
        um: "EA",
        cost: product?.aspetto_price,
        // margin: parseFloat(margin.toFixed(2)),
        margin: truncateFormat(margin, 2),
        customerCost: product?.customer_price,
        totalSkuCost: product?.aspetto_price,
      });
    }
    calculateCosts();
    toast.success(`Product ${product.sku_display_name} is added successfully`);
  };
  const handleLockUnLock = (e, index, type) => {
    e.stopPropagation();
  };
  useEffect(() => {
    const existingCards = getValues("cards");
    if (!existingCards || existingCards.length === 0) {
      appendCard({
        vendorPartner: "",
        skuId: "",
        skuDescription: "",
        productName: "",
        qty: 1,
        um: "EA",
        cost: "",
        margin: 0,
        customerCost: "",
        totalSkuCost: "",
      });
    }
  }, [appendCard, getValues]);

  const handleRemoveCard = (index) => {
    if (cardFields.length > 1) {
      // Remove warnings for the deleted card

      setVendorWarnings((prev) => {
        const updated = { ...prev };
        delete updated[index];
        // Reindex warnings to match new card indices
        const reindexed = {};
        Object.keys(updated).forEach((key) => {
          const oldIndex = parseInt(key);
          if (oldIndex > index) {
            reindexed[oldIndex - 1] = updated[oldIndex];
          } else if (oldIndex < index) {
            reindexed[oldIndex] = updated[oldIndex];
          }
        });
        return reindexed;
      });

      // Remove and reindex originalVendors
      const currentOriginalVendors = getValues("originalVendorsPurchase") || {};
      const updatedOriginalVendors = {};
      Object.keys(currentOriginalVendors).forEach((key) => {
        const oldIndex = parseInt(key);
        if (oldIndex !== index) {
          const newIndex = oldIndex > index ? oldIndex - 1 : oldIndex;
          updatedOriginalVendors[newIndex] = currentOriginalVendors[oldIndex];
        }
      });
      setValue("originalVendorsPurchase", updatedOriginalVendors);

      removeCard(index);
      setTimeout(() => {
        const updatedCards = getValues("cards");
        calculateCosts(updatedCards);
      }, 0);
    }
  };

  // const handleRemoveCard = (index) => {
  //   const currentCards = getValues("cards");
  //   if (cardFields.length > 1) {
  //     removeCard(index);
  //     setTimeout(() => {
  //       const updatedCards = getValues("cards");
  //       calculateCosts(updatedCards);
  //     }, 0);
  //   }
  // };

  const handleRemoveOthercost = (index) => {
    const currentOthercost = getValues("otherCost");
    if (otherCostFields.length > 0) {
      removeOtherCost(index);
      setTimeout(() => {
        const updatedOthercost = getValues("otherCost");
        calculateCosts(updatedOthercost);
      }, 0);
    }
  };

  const handleDragEnd = (result) => {
    const { destination, source } = result;
    if (!destination || destination.index === source.index) return;
    const currentValues = getValues("cards");
    const reorderedCards = [...currentValues];
    const [removed] = reorderedCards.splice(source.index, 1);
    reorderedCards.splice(destination.index, 0, removed);
    setValue("cards", reorderedCards);

    // Reorder originalVendors to match the new card order
    const currentOriginalVendors = getValues("originalVendorsPurchase") || {};
    const reorderedOriginalVendors = {};
    Object.keys(currentOriginalVendors).forEach((key) => {
      const oldIndex = parseInt(key);
      let newIndex = oldIndex;
      if (oldIndex === source.index) {
        newIndex = destination.index;
      } else if (
        oldIndex >= Math.min(source.index, destination.index) &&
        oldIndex <= Math.max(source.index, destination.index)
      ) {
        newIndex = oldIndex > source.index ? oldIndex - 1 : oldIndex + 1;
      }
      reorderedOriginalVendors[newIndex] = currentOriginalVendors[oldIndex];
    });
    setValue("originalVendorsPurchase", reorderedOriginalVendors);

    // Reorder vendorWarnings
    const reorderedVendorWarnings = {};
    Object.keys(vendorWarnings).forEach((key) => {
      const oldIndex = parseInt(key);
      let newIndex = oldIndex;
      if (oldIndex === source.index) {
        newIndex = destination.index;
      } else if (
        oldIndex >= Math.min(source.index, destination.index) &&
        oldIndex <= Math.max(source.index, destination.index)
      ) {
        newIndex = oldIndex > source.index ? oldIndex - 1 : oldIndex + 1;
      }
      reorderedVendorWarnings[newIndex] = vendorWarnings[oldIndex];
    });
    setVendorWarnings(reorderedVendorWarnings);
  };

  // const handleDragEnd = (result) => {
  //   const { destination, source } = result;
  //   if (!destination || destination.index === source.index) return;
  //   const currentValues = getValues("cards");
  //   const reorderedCards = [...currentValues];
  //   const [removed] = reorderedCards.splice(source.index, 1);
  //   reorderedCards.splice(destination.index, 0, removed);
  //   setValue("cards", reorderedCards);
  // };

  // const calculateCosts = (name) => {
  //   console.log("the field that changed is", name);
  //   let currentfield = "";
  //   if (typeof name === "string") {
  //     const pathParts = name.match(/cards\[(\d+)\]\.(\w+)/);
  //     ////  let currentindex = pathParts ? parseInt(pathParts[1]) : null;
  //     currentfield = pathParts ? pathParts[2] : null;
  //   }
  //   let totalBeforeMargin = 0;
  //   let totalAfterMargin = 0;
  //   const cards = getValues("cards") || [];
  //   const otherCost = getValues("otherCost") || [];
  //   const shippingCost = parseFloat(getValues("shippingCost")) || 0;
  //   const tax = parseFloat(getValues("tax")) || 0;
  //   cards?.forEach((card, index) => {
  //     if (currentfield != "") {
  //       const customerCostLock = card.customerCostLock;
  //       const costLock = card.CostLock;
  //       const marginLock = card.marginLock;
  //       // console.log('customerCostLock', customerCostLock);
  //       // console.log('costLock', costLock);
  //       // console.log('marginLock', marginLock);
  //       const qty = parseFloat(card.qty) || 0;
  //       let cost = parseFloat(card.cost) || 0;
  //       let margin = parseFloat(card.margin) || 0;
  //       let customerCost = parseFloat(card.customerCost) || 0;
  //       let totalSkuCost = 0;
  //       const lockFields = ["customerCostLock", "CostLock", "marginLock"];

  //       if (lockFields.includes(currentfield)) {
  //         return;
  //       }

  //       if (
  //         customerCostLock == false &&
  //         costLock == false &&
  //         marginLock == false
  //       ) {
  //         if (currentfield == "customerCost") {
  //           console.log("customer cost change , need to calculate margin");
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           if (cost == 0) {
  //             margin = 0;
  //             setValue(
  //               `cards[${cards.indexOf(card)}].cost`,
  //               truncateFormat(totalSkuCost, 2)
  //             );
  //           } else {
  //             margin = parseFloat(((customerCost - cost) / customerCost) * 100);
  //           }
  //           setValue(
  //             `cards[${cards.indexOf(card)}].margin`,
  //             truncateFormat(margin, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //           // setValue(`cards[${cards.indexOf(card)}].margin`, margin.toFixed(2));
  //           // setValue(
  //           //   `cards[${cards.indexOf(card)}].totalSkuCost`,
  //           //   totalSkuCost.toFixed(2)
  //           // );
  //         } else {
  //           console.log("cost change , need to calculate customer cost");
  //           // const customerCost = cost * (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].customerCost`,
  //             truncateFormat(customerCost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         }
  //       } else if (customerCostLock == true) {
  //         console.log("customer cost lock is true");
  //         if (currentfield == "cost") {
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           margin = parseFloat(((customerCost - cost) / customerCost) * 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].margin`,
  //             truncateFormat(margin, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else if (currentfield == "margin") {
  //           const costCust = customerCost * (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].cost`,
  //             truncateFormat(costCust, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           console.log("customer cost change , need to calculate cost");
  //           // margin
  //           // cost = customerCost / (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].cost`,
  //             truncateFormat(cost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         }
  //       } else if (marginLock == true) {
  //         if (currentfield == "cost") {
  //           console.log("margin lock cost change");
  //           // const customerCost = cost * (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].customerCost`,
  //             truncateFormat(customerCost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else if (currentfield == "customerCost") {
  //           const costCust = customerCost * (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].cost`,
  //             truncateFormat(costCust, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           console.log("margin lock customer cost change");
  //           // customer cost
  //           // cost = customerCost / (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].cost`,
  //             truncateFormat(cost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         }
  //       } else if (costLock == true) {
  //         if (currentfield == "margin") {
  //           console.log("cost lock margin change");
  //           // const customerCost = cost * (1 + margin / 100);
  //           const customerCost = cost / (1 - margin / 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].customerCost`,
  //             truncateFormat(customerCost, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         } else {
  //           console.log("cost lock ");
  //           // customer cost change , need to calculate margin
  //           // margin = parseFloat((customerCost / cost - 1) * 100);
  //           margin = parseFloat(((customerCost - cost) / customerCost) * 100);
  //           // totalSkuCost = parseFloat(customerCost) * qty;
  //           totalSkuCost = parseFloat(truncateFormat(customerCost, 2)) * qty;
  //           setValue(
  //             `cards[${cards.indexOf(card)}].margin`,
  //             truncateFormat(margin, 2)
  //           );
  //           setValue(
  //             `cards[${cards.indexOf(card)}].totalSkuCost`,
  //             truncateFormat(totalSkuCost, 2)
  //           );
  //         }
  //       }
  //       totalBeforeMargin += cost * qty;
  //       totalAfterMargin += parseFloat(totalSkuCost);
  //     } else {
  //       totalBeforeMargin += parseFloat(card.cost * card.qty);
  //       totalAfterMargin += parseFloat(card.customerCost * card.qty);
  //     }
  //   });
  //   // Calculate costs for each other cost
  //   otherCost?.forEach((costItem) => {
  //     const amount = parseFloat(costItem.Amount) || 0;
  //     if (amount > 0) {
  //       totalBeforeMargin += parseFloat(amount);
  //       totalAfterMargin += parseFloat(amount);
  //     }
  //   });
  //   if (shippingCost > 0) {
  //     totalBeforeMargin += parseFloat(shippingCost);
  //     totalAfterMargin += parseFloat(shippingCost);
  //   }
  //   // Add tax if enabled
  //   if (tax > 0) {
  //     // console.log('tax', tax);
  //     totalBeforeMargin += parseFloat(tax);
  //     totalAfterMargin += parseFloat(tax);
  //   }
  //   // Set the final values
  //   setTotalCostBeforeMargin(truncateFormat(totalBeforeMargin, 2));
  //   setTotalCostAfterMargin(truncateFormat(totalAfterMargin, 2));
  //   // Update form state
  //   setValue("totalCostBeforeMargin", truncateFormat(totalBeforeMargin, 2));
  //   setValue("totalCostAfterMargin", truncateFormat(totalAfterMargin, 2));
  // };

  const calculateCosts = (name) => {
    console.log("the field that changed is", name);
    let currentfield = "";
    if (typeof name === "string") {
      const pathParts = name.match(/cards\[(\d+)\]\.(\w+)$/);
      currentfield = pathParts ? pathParts[2] : null;
    }

    let totalBeforeMargin = 0;
    let totalAfterMargin = 0;
    const cards = getValues("cards") || [];
    const otherCost = getValues("otherCost") || [];
    const shippingCost = parseFloat(getValues("shippingCost")) || 0;
    const tax = parseFloat(getValues("tax")) || 0;

    cards?.forEach((card, index) => {
      if (currentfield != "") {
        const customerCostLock = card.customerCostLock;
        const costLock = card.CostLock;
        const marginLock = card.marginLock;

        const qty = parseFloat(card.qty) || 0;
        let cost = parseFloat(card.cost) || 0;
        let margin = parseFloat(card.margin) || 0;
        let customerCost = parseFloat(card.customerCost) || 0;
        let totalSkuCost = 0;
        const lockFields = ["customerCostLock", "CostLock", "marginLock"];

        if (lockFields.includes(currentfield)) {
          return;
        }

        if (
          customerCostLock == false &&
          costLock == false &&
          marginLock == false
        ) {
          if (currentfield == "customerCost") {
            console.log("customer cost change , need to calculate margin");

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            if (cost == 0) {
              margin = 0;
              setValue(
                `cards[${cards.indexOf(card)}].cost`,
                roundToMoney(totalSkuCost),
              );
            } else {
              margin = parseFloat(
                ((roundedCustomerCost - cost) / roundedCustomerCost) * 100,
              );
            }
            setValue(
              `cards[${cards.indexOf(card)}].margin`,
              roundToMoney(margin),
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else {
            console.log("cost change , need to calculate customer cost");
            const customerCost = cost / (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].customerCost`,
              roundedCustomerCost,
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          }
        } else if (customerCostLock == true) {
          console.log("customer cost lock is true");

          if (currentfield == "cost") {
            margin = parseFloat(((customerCost - cost) / customerCost) * 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].margin`,
              roundToMoney(margin),
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else if (currentfield == "margin") {
            const costCust = customerCost * (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].cost`,
              roundToMoney(costCust),
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else {
            console.log("customer cost change , need to calculate cost");
            const customerCost = cost / (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(`cards[${cards.indexOf(card)}].cost`, roundToMoney(cost));
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          }
        } else if (marginLock == true) {
          if (currentfield == "cost") {
            console.log("margin lock cost change");
            const customerCost = cost / (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].customerCost`,
              roundedCustomerCost,
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else if (currentfield == "customerCost") {
            const costCust = customerCost * (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].cost`,
              roundToMoney(costCust),
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else {
            console.log("margin lock customer cost change");
            const customerCost = cost / (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(`cards[${cards.indexOf(card)}].cost`, roundToMoney(cost));
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          }
        } else if (costLock == true) {
          if (currentfield == "margin") {
            console.log("cost lock margin change");
            const customerCost = cost / (1 - margin / 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].customerCost`,
              roundedCustomerCost,
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          } else {
            console.log("cost lock ");
            margin = parseFloat(((customerCost - cost) / customerCost) * 100);

            // Round customerCost first, then multiply
            const roundedCustomerCost = roundToMoney(customerCost);
            totalSkuCost = roundedCustomerCost * qty;

            setValue(
              `cards[${cards.indexOf(card)}].margin`,
              roundToMoney(margin),
            );
            setValue(
              `cards[${cards.indexOf(card)}].totalSkuCost`,
              roundToMoney(totalSkuCost),
            );
          }
        }

        // FIXED: Use rounded values for accumulation
        totalBeforeMargin += roundToMoney(cost * qty);
        totalAfterMargin += roundToMoney(totalSkuCost);
      } else {
        totalBeforeMargin += parseFloat(card.cost * card.qty);
        totalAfterMargin += parseFloat(card.customerCost * card.qty);
      }
    });

    // Calculate costs for each other cost
    otherCost?.forEach((costItem) => {
      const amount = parseFloat(costItem.Amount) || 0;
      if (amount > 0) {
        totalBeforeMargin += parseFloat(amount);
        totalAfterMargin += parseFloat(amount);
      }
    });

    if (shippingCost > 0) {
      totalBeforeMargin += parseFloat(shippingCost);
      totalAfterMargin += parseFloat(shippingCost);
    }

    // Add tax if enabled
    if (tax > 0) {
      totalBeforeMargin += parseFloat(tax);
      totalAfterMargin += parseFloat(tax);
    }

    // Set the final values - FIXED
    setTotalCostBeforeMargin(roundToMoney(totalBeforeMargin));
    setTotalCostAfterMargin(roundToMoney(totalAfterMargin));

    // Update form state - FIXED
    setValue("totalCostBeforeMargin", roundToMoney(totalBeforeMargin));
    setValue("totalCostAfterMargin", roundToMoney(totalAfterMargin));
  };

  const isCalculating = useRef(false);
  const shipping_terms = watch("shipping_terms");
  useEffect(() => {
    if (shipping_terms === "FOB Destination") {
      setShippingHide(true);
    }
  }, [watch("shipping_terms")]);
  useEffect(() => {
    const subscription = watch((value, { name }) => {
      //console.log('set name',name);
      const match = name?.match(
        /cards\[(\d+)\]\.(qty|cost|margin|customerCost)$/,
      );
      const otherCostMatch = name?.match(/otherCost\[(\d+)\]\.Amount/);
      if (match || otherCostMatch) {
        if (!isCalculating.current) {
          isCalculating.current = true;
          calculateCosts(name);
          isCalculating.current = false;
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);
  useEffect(() => {
    if (!isCalculating.current) {
      isCalculating.current = true;
      calculateCosts();
      isCalculating.current = false;
    }
  }, [watch("shippingCost"), watch("tax"), watch("cards"), watch("otherCost")]);
  const [activeCardIndex, setActiveCardIndex] = useState(null);
  const [cardSearch, setCardSearch] = useState(
    cardFields.map(() => ({
      vendor: "",
      description: "",
      sku: "",
      showSuggestions: true,
    })),
  );

  const handleInputFocus = (index) => {
    setActiveCardIndex(index);
    const updatedCardSearch = cardSearch.map((card, idx) => {
      if (idx !== index) {
        return { ...card, showSuggestions: false };
      }
      return card;
    });
    setCardSearch(updatedCardSearch);
  };

  const handleBlur = (index) => {
    // setDataSuggetion(null);
    // setTimeout(() => {
    //   const updatedCardSearch = [...cardSearch];
    //   updatedCardSearch[index] = {
    //     ...updatedCardSearch[index],
    //     showSuggestions: false,
    //   };
    //   setCardSearch(updatedCardSearch);
    // }, 150);
  };

  const suggestionBoxRefs = useRef([]);
  const vendorSuggestionRefs = useRef([]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside all suggestion boxes
      const isClickOutside = cardSearch.every((_, index) => {
        const suggestionBox = suggestionBoxRefs.current[index];
        return suggestionBox && !suggestionBox.contains(event.target);
      });

      if (isClickOutside) {
        // Close all suggestion boxes and clear suggestions
        setDataSuggetion(null);
        setCardSearch((prev) =>
          prev.map((card) => ({
            ...card,
            showSuggestions: false,
          })),
        );
      }

      const isVendorOutside = vendorSuggestionRefs.current.every((box) =>
        box ? !box.contains(event.target) : true,
      );

      if (isVendorOutside) {
        setSuggestionData([]);
        setSearchDebounces({ searchName: "" });
      }
    };

    // Add event listener for mousedown
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [cardSearch]);

  const handleSearchChange = (index, field, value) => {
    const vendorPartner = watch(`cards[${index}].vendorPartner`) || "";
    const updatedCardSearch = [...cardSearch];
    if (field === "sku") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        sku: value,
        vendor: vendorPartner,
        description: "",
        showSuggestions: true,
      };
    } else if (field === "vendor") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        vendor: value,
        sku: "",
        description: "",
        showSuggestions: true,
      };
    } else if (field === "description") {
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        description: value,
        sku: "",
        vendor: "",
        showSuggestions: true,
      };
    }
    setCardSearch(updatedCardSearch);
  };

  const { postData: fetchProductSearch, data } = usePostRequest(
    API_ENDPOINTS.PRODUCT_SUGGETION,
  );
  const onSuccessData = (data) => {
    setDataSuggetion(data);
  };

  useEffect(() => {
    const vendorPartner =
      watch(`cards[${activeCardIndex}].vendorPartner`) || "";
    console.log("vendorPartner", vendorPartner);
    if (
      activeCardIndex === null ||
      !cardSearch[activeCardIndex]?.showSuggestions
    ) {
      return;
    }
    const { vendor, sku, description } = cardSearch[activeCardIndex];
    if (!vendor && !sku && !description) {
      return;
    }
    const debounceTimer = setTimeout(() => {
      const KitProduct = watch("product_sales");
      const ordertype = watch("ordertype");

      const requestPayload = {
        page,
        limit,
        order_status: ordertype,
        module_type: "ORDER",
        vendor: vendorPartner?.length > 0 ? vendorPartner : undefined,
        sku: sku?.length > 0 ? sku : undefined,
        description: description?.length > 0 ? description : undefined,
      };

      // if (ordertype === "CRK" && Array.isArray(KitProduct)) {
      //  requestPayload.kit_ids = KitProduct.map(item => item.skuId);
      // }

      if (
        ordertype === "CRK" ||
        ordertype === "DS" ||
        ordertype === "KIT" ||
        ordertype === "S"
      ) {
        // requestPayload.kit_ids = KitProduct.map(item => item.skuId);
        requestPayload.kit_ids = "custom";
      }

      fetchProductSearch(requestPayload, onSuccessData);
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [cardSearch, page, limit, activeCardIndex]);

  const recalcSalesRow = useCallback(
    (index) => {
      const rowPath = `product_sales[${index}]`;
      const qty = parseFloat(getValues(`${rowPath}.qty`)) || 0;
      const cost = parseFloat(getValues(`${rowPath}.cost`)) || 0;
      const margin = parseFloat(getValues(`${rowPath}.margin`)) || 0;

      // margin fixed here → derive customer price from cost & margin
      const customerCost = margin === 0 ? cost : cost / (1 - margin / 100);
      const roundedCustomerCost = roundToMoney(customerCost);

      setValue(`${rowPath}.customerCost`, roundedCustomerCost);
      setValue(
        `${rowPath}.totalSkuCost`,
        roundToMoney(roundedCustomerCost * qty),
      );
      setValue(`${rowPath}.purchaseCost`, roundToMoney(cost * qty));

      // recompute sales totals
      const sales = getValues("product_sales") || [];
      const otherCostSales = getValues("other_cost_json_sales") || [];
      const shippingCostsales = parseFloat(getValues("shippingCostsales")) || 0;
      const taxsales = parseFloat(getValues("taxsales")) || 0;

      let before = 0;
      let after = 0;
      sales.forEach((c) => {
        const q = parseFloat(c.qty) || 0;
        const cst = parseFloat(c.cost) || 0;
        const cc = parseFloat(c.customerCost) || 0;
        before += cst * q;
        after += roundToMoney(cc) * q;
      });
      otherCostSales.forEach((oc) => {
        const amt = parseFloat(oc.Amount) || 0;
        if (amt > 0) {
          before += amt;
          after += amt;
        }
      });
      if (shippingCostsales > 0) {
        before += shippingCostsales;
        after += shippingCostsales;
      }
      if (taxsales > 0) {
        before += taxsales;
        after += taxsales;
      }

      setValue("totalCostBeforeMarginSales", roundToMoney(before));
      setValue("totalCostAfterMarginSales", roundToMoney(after));
    },
    [getValues, setValue],
  );

  const textAreaRefs = useRef([]);
  const salesDescWasEmpty = useRef({}); // ADD

  const adjustTextAreaHeight = useCallback(
    (index) => {
      const textArea = textAreaRefs.current[index];
      if (textArea) {
        textArea.style.height = "auto";
        textArea.style.height = `${textArea.scrollHeight}px`;
      }
    },
    [textAreaRefs],
  );

  const handleCopySalesProductsToCards = useCallback(() => {
    const salesProducts = getValues("product_sales") ?? [];

    const newCards = salesProducts.map((sp) => ({
      vendorPartner: sp.vendorPartner ?? "",
      skuId: sp.skuId ?? "",
      skuIdUnique: sp.skuIdUnique ?? "",
      skuDescription: sp.prodDescription ?? sp.skuDescription ?? "",
      qty: Number(sp.qty) || 1,
      um: sp.um ?? "EA",
      cost: sp.cost ?? "",
      margin: sp.margin ?? 0,
      customerCost: sp.customerCost ?? "",
      totalSkuCost: sp.totalSkuCost ?? "",
    }));

    const startIdx = cardFields.length;
    appendCard(newCards, { shouldValidate: true });

    const currentOriginal = getValues("originalVendorsPurchase") ?? {};
    const originalVendorsForNew = {};

    newCards.forEach((_, i) => {
      originalVendorsForNew[startIdx + i] =
        salesProducts[i].vendorPartner ?? "";
    });

    setValue("originalVendorsPurchase", {
      ...currentOriginal,
      ...originalVendorsForNew,
    });

    setVendorWarnings((prev) => {
      const cleared = { ...prev };
      newCards.forEach((_, i) => delete cleared[startIdx + i]);
      return cleared;
    });

    setTimeout(() => calculateCosts(), 0);

    toast.success(`${salesProducts.length} product(s) copied from Sales`);
  }, [
    getValues,
    cardFields.length,
    appendCard,
    setValue,
    setVendorWarnings,
    calculateCosts,
  ]);

  const handleProductSelect = useCallback(
    async (product, index) => {
      const currentValues = getValues("cards") || [];

      // const isDuplicate = currentValues.some(
      //   (item, idx) => item?.skuIdUnique === product?.sku_id && idx !== index
      // );

      const updatedCardSearch = [...cardSearch];
      updatedCardSearch[index] = {
        ...updatedCardSearch[index],
        showSuggestions: false,
      };
      setCardSearch(updatedCardSearch);

      // if (isDuplicate) {
      //   toast.error(
      //     `Product with SKU ${product.sku_display_name} already exists.`
      //   );
      //   return;
      // }

      setVendorWarnings((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });

      const currentOriginalVendors = getValues("originalVendorsPurchase") || {};
      setValue("originalVendorsPurchase", {
        ...currentOriginalVendors,
        [index]: product?.Vendor?.display_name,
      });

      // Update form values with the selected product data
      setValue(`cards[${index}].vendorPartner`, product?.Vendor?.display_name, {
        shouldValidate: true,
      });
      setValue(`cards[${index}].skuIdUnique`, product?.sku_id, {
        shouldValidate: true,
      });
      setValue(`cards[${index}].productName`, product?.name, {
        shouldValidate: true,
      });
      setValue(`cards[${index}].skuId`, product?.sku_display_name, {
        shouldValidate: true,
      });
      setValue(`cards[${index}].skuDescription`, product?.description, {
        shouldValidate: true,
      });
      setValue(`cards[${index}].salesDescription`, product?.description_sales, {
        shouldValidate: true,
      });
      setValue(`cards[${index}].um`, product?.uoi, { shouldValidate: true });
      setValue(`cards[${index}].cost`, product?.aspetto_price, {
        shouldValidate: true,
      });
      setValue(`cards[${index}].customerCost`, product?.customer_price, {
        shouldValidate: true,
      });
      if (product?.customer_price === "0.00") {
        setValue(`cards[${index}].margin`, "8", {
          shouldValidate: true,
        });
      }
      // setValue(`cards[${index}].margin`, product?.margin_percent, {
      //   shouldValidate: true,
      // });
      const textArea = textAreaRefs.current[index];
      if (textArea) {
        textArea.value = product?.description;
        adjustTextAreaHeight(index);
      }
      // const updatedCardSearch = [...cardSearch];
      // updatedCardSearch[index] = {
      //   ...updatedCardSearch[index],
      //   showSuggestions: false,
      // };
      // setCardSearch(updatedCardSearch);
      await trigger("cards");
      // syncProductSalesWithCards()
    },
    [setValue, textAreaRefs, adjustTextAreaHeight, cardSearch, setCardSearch],
  );

  useEffect(() => {
    cardFields.forEach((_, index) => {
      adjustTextAreaHeight(index);
    });
  }, [cardFields]);

  const cards = watch("cards");
  // console.log("cards", cards);

  // console.log("cards value", cards);
  const handleLockChange = (field, index) => {
    const currentState = watch(`cards[${index}]`);
    if (currentState[field]) {
      setValue(`cards[${index}].${field}`, false);
    } else {
      setValue(`cards[${index}].CostLock`, field === "CostLock");
      setValue(`cards[${index}].marginLock`, field === "marginLock");
      setValue(
        `cards[${index}].customerCostLock`,
        field === "customerCostLock",
      );
    }
  };

  // useEffect(() => {
  //   if (vendorPartner?.length > 0) {
  //     const existingAVendors = getValues("aVendors") || [];

  //     const vendorPartnerNames = new Set(
  //       vendorPartner.map((v) => v?.vendorPartner?.trim().toLowerCase()),
  //     );

  //     const filteredExistingAVendors = existingAVendors.filter(
  //       (vendor) =>
  //         vendor?.display_name &&
  //         vendorPartnerNames.has(vendor.display_name.trim().toLowerCase()),
  //     );

  //     const existingNames = new Set(
  //       filteredExistingAVendors.map((v) =>
  //         v.display_name.trim().toLowerCase(),
  //       ),
  //     );

  //     const newNames = new Set();
  //     const newVendors = vendorPartner.reduce((acc, item) => {
  //       const rawName = item?.vendorPartner;
  //       const name = rawName?.trim().toLowerCase();

  //       if (name && !existingNames.has(name) && !newNames.has(name)) {
  //         acc.push({ display_name: rawName.trim() });
  //         newNames.add(name);
  //       }

  //       return acc;
  //     }, []);

  //     const merged = [...filteredExistingAVendors, ...newVendors];

  //     setValue("aVendors", merged);
  //   } else {
  //     setValue("aVendors", []);
  //   }
  // }, [vendorPartner, getValues, setValue, handleProductSelect]);

  const updateTextAreaWithDescription = (index, description) => {
    const textArea = textAreaRefs.current[index];
    if (textArea) {
      textArea.value = description;
      adjustTextAreaHeight(index);
    }
  };

  const OrderTypes = watch("ordertype");
  const productSales = watch("product_sales");
  const duplicateValues = watch("other_cost_json_sales");
  const taxsales = watch("taxsales");
  const shippingCostPurchase = watch("shippingCostsales");
  const totalCostBeforeMarginPurchase = watch("totalCostBeforeMarginSales");
  const totalCostAfterMarginPurchase = watch("totalCostAfterMarginSales");

  // ADD HERE
  useEffect(() => {
    if (!["M", "CRK", "DS", "S"].includes(OrderTypes)) return;
    const sales = getValues("product_sales") || [];
    sales.forEach((sp, i) => {
      if (!sp?.prodDescription || sp.prodDescription.trim() === "") {
        setValue(
          `product_sales[${i}].prodDescription`,
          sp?.skuDescription || "",
        );
      }
    });
  }, [OrderTypes, productSales?.length, getValues, setValue]);

  // useEffect(() => {
  //   if (ordertype === "DS" || ordertype === "M") {
  //     setValue("totalCostBeforeMargin", totalCostBeforeMarginPurchase);
  //     setValue("totalCostAfterMargin", totalCostAfterMarginPurchase);
  //   }
  // }, [
  //   ordertype,
  //   totalCostBeforeMarginPurchase,
  //   totalCostAfterMarginPurchase,
  //   setValue,
  // ]);

  const user = useSelector((state) => state.auth.user);
  const allowedRoles = ["super-admin"];
  const isSuperAdmin = user?.roles?.some((role) => allowedRoles.includes(role));
  const isFinanceHead = user?.is_finance_department_head === true;
  const isDeptHead = user?.is_department_head;

  const order_status = getValues("orderStatus");

  const canEditProducts = (() => {
    if (!order_id) return true;

    if (order_status === "PENDING") return true;

    return isSuperAdmin || isDeptHead;
  })();

  // ---- Kit grouping helpers ----
  const KIT_BORDER_COLORS = [
    // "#1565c0",
    // "#2e7d32",
    // "#e65100",
    // "#6a1b9a",
    // "#b71c1c",
    "#1d1d1d",
  ];
  const KIT_BG_COLORS = [
    "#f5f7f8",
    //  "#e8f5e9", "#fff3e0", "#f3e5f5", "#fce4ec"
  ];
  // const kitColorMap = (() => {
  //   if (ordertype !== "KIT") return {};
  //   const map = {};
  //   let idx = 0;
  //   (cards || []).forEach((c) => {
  //     if (c?.kit_name && !map[c.kit_name]) {
  //       map[c.kit_name] = {
  //         border: KIT_BORDER_COLORS[idx % KIT_BORDER_COLORS.length],
  //         bg: KIT_BG_COLORS[idx % KIT_BG_COLORS.length],
  //       };
  //       idx++;
  //     }
  //   });
  //   return map;
  // })();

  const kitColorMap = (() => {
    // if (ordertype !== "KIT") return {};
    const map = {};
    let idx = 0;
    (cards || []).forEach((c) => {
      const kitKey = c?.kit_raw_sku_id;
      if (kitKey && !map[kitKey]) {
        map[kitKey] = {
          border: KIT_BORDER_COLORS[idx % KIT_BORDER_COLORS.length],
          bg: KIT_BG_COLORS[idx % KIT_BG_COLORS.length],
          name: c?.kit_name,
        };
        idx++;
      }
    });
    return map;
  })();

  console.log("duplicateValues", duplicateValues);
  return (
    <>
      {showModal && (
        <SearchPopUp
          // syncProductSalesWithCards={syncProductSalesWithCards}
          calculateCosts={calculateCosts}
          order_ref_type={order_ref_type}
          show={showModal}
          ordertype={ordertype}
          searchProps={searchProps}
          setSearchProps={setSearchProps}
          setShow={setShowModal}
          onAddSku={handleAddSku}
          setCardSearch={setCardSearch}
          cardSearch={cardSearch}
          updateTextArea={updateTextAreaWithDescription}
        />
      )}

      {/* {OrderTypes === "M" ||
      OrderTypes === "CRK" ||
      OrderTypes === "DS" ||
      OrderTypes === "S" ? (
        <div className="drag_section">
          <DragDropContext>
            <Droppable droppableId="droppable-cards">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {productSales?.map((card, index) => (
                    <Draggable
                      key={card.id}
                      draggableId={`card-${index}`}
                      index={index}
                    >
                      {(provided) => (
                        <Card
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="mb-3"
                        >
                          <Card.Body>
                            <div className="grag_flex_row">
                              
                              <Col className="mob_50">
                                <Form.Group>
                                  <Form.Label className="required">
                                    VENDOR'S PARTNER
                                  </Form.Label>
                                  <InputGroup>
                                    <Form.Control
                                      disabled={true}
                                      defaultValue={card.vendorPartner}
                                      placeholder="Enter Name"
                                      // value={cardSearch[activeCardIndex]?.vendor || ""}
                                      onBlur={() => handleBlur(index)}
                                      // onChange={handleSearchByName}
                                      // onChange={(e) =>
                                      //   handleSearchChange(
                                      //     activeCardIndex,
                                      //     "vendor",
                                      //     e.target.value
                                      //   )
                                      // }
                                    />
                                  </InputGroup>
                                  {errors?.cards?.[index]?.vendorPartner && (
                                    <span className="text-danger">
                                    </span>
                                  )}
                                </Form.Group>
                              </Col>
                              <div className="mid_drag_column mob_50">
                                <Form.Group>
                                  <Form.Label className="">
                                    PRODUCT NAME
                                  </Form.Label>
                                  <InputGroup>
                                    <Form.Control
                                      placeholder="Product Name"
                                      disabled={true}
                                      defaultValue={card.productName}
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </div>
                              {showSkuId && (
                                <>
                                  <Col className="mid_drag_column mob_50">
                                    <Form.Group>
                                      <Form.Label className="required">
                                        UNIQUE SKU ID
                                      </Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          disabled={true}
                                          placeholder="SKU ID"
                                          defaultValue={card.skuIdUnique}
                                        />
                                      </InputGroup>
                                    </Form.Group>
                                  </Col>
                                  <Col className="mid_drag_column mob_50">
                                    <Form.Group>
                                      <Form.Label className="required">
                                        ROW ID
                                      </Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          disabled={true}
                                          placeholder="SKU ID"
                                          defaultValue={card.rowId}
                                        />
                                      </InputGroup>
                                    </Form.Group>
                                  </Col>
                                </>
                              )}
                              <Col className="mid_drag_column mob_50">
                                <Form.Group>
                                  <Form.Label className="required">
                                    SKU ID
                                  </Form.Label>
                                  <InputGroup>
                                    <Form.Control
                                      disabled={true}
                                      // value={watch(`cards[${index}].skuId`)}
                                      placeholder="SKU ID"
                                      defaultValue={card.skuId}
                                      onBlur={() => handleBlur(index)}
                                      onFocus={() => handleInputFocus(index)}
                                    />
                                  </InputGroup>
                                  {errors?.cards?.[index]?.skuId && (
                                    <span className="text-danger">
                                    </span>
                                  )}
                                </Form.Group>
                              </Col>
                              <Col className="mob_100">
                                <Form.Group>
                                  <Form.Label className="">
                                    SKU DESCRIPTION
                                  </Form.Label>
                                  <InputGroup>
                                    <Form.Control
                                      as="textarea"
                                      disabled={order_ref_type === "project"}
                                      rows={1}
                                      {...register(
                                        `product_sales[${index}].prodDescription`,
                                      )}
                                      onBlur={() => handleBlur(index)}
                                      placeholder="Description"
                                      ref={(el) => {
                                        register(
                                          `product_sales[${index}].prodDescription`,
                                        ).ref(el);
                                        textAreaRefs.current[index] = el;
                                        adjustTextAreaHeight(index);
                                      }}
                                      style={{
                                        resize: "none",
                                        overflow: "hidden",
                                      }}
                                      onFocus={() => {
                                        const salesDesc = getValues(
                                          `product_sales[${index}].skuDescription`,
                                        );
                                        salesDescWasEmpty.current[index] =
                                          !salesDesc || salesDesc.trim() === "";
                                        handleInputFocus(index);
                                      }}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        setValue(
                                          `product_sales[${index}].prodDescription`,
                                          value,
                                        );
                                        if (salesDescWasEmpty.current[index]) {
                                          setValue(
                                            `product_sales[${index}].skuDescription`,
                                            value,
                                          );
                                        }
                                        adjustTextAreaHeight(index);
                                      }}
                                    />
                                    
                                  </InputGroup>
                                </Form.Group>
                              </Col>

                              <Col className="small_drag_column mob_50">
                                <Form.Group>
                                  <Form.Label className="required">
                                    QTY
                                  </Form.Label>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      onKeyDown={handleKeyDown}
                                      defaultValue={card.qty}
                                      placeholder="0"
                                      disabled={
                                        order_ref_type === "project" ||
                                        !canEditProducts
                                      }
                                      {...register(
                                        `product_sales[${index}].qty`,
                                        {
                                          required: "Quantity is required",
                                          // pattern: {
                                          //   value: /^[0-9]+$/,
                                          //   message:
                                          //     "Quantity must be a number",
                                          // },
                                          pattern: {
                                            value: /^[0-9]*\.?[0-9]+$/,
                                            message:
                                              "Quantity must be a valid number",
                                          },
                                        },
                                      )}
                                      onChange={(e) => {
                                        // const value = Number(e.target.value);
                                        // const maxQty = getValues(
                                        //   `product_sales[${index}].max_quantity`,
                                        // );
                                        const rawValue = e.target.value;
                                        const numericValue =
                                          parseFloat(rawValue);
                                        const maxQty = getValues(
                                          `product_sales[${index}].max_quantity`,
                                        );
                                        // if (maxQty && value > maxQty) {
                                        if (maxQty && numericValue > maxQty) {
                                          toast.error(
                                            `Maximum allowed quantity is ${maxQty}`,
                                          );
                                          setValue(
                                            `product_sales[${index}].qty`,
                                            maxQty || card.qty,
                                            {
                                              shouldValidate: true,
                                            },
                                          );
                                        } else {
                                          setValue(
                                            `product_sales[${index}].qty`,
                                            // value,
                                            rawValue,
                                            { shouldValidate: true },
                                          );
                                        }
                                        recalcSalesRow(index);
                                      }}
                                    />
                                    
                                  </InputGroup>
                                  {errors?.cards?.[index]?.qty && (
                                    <span className="text-danger">
                                    </span>
                                  )}
                                </Form.Group>
                              </Col>

                              <Col className="small_drag_column mob_50">
                                <Form.Group>
                                  <Form.Label>UM</Form.Label>
                                  <InputGroup>
                                    <Form.Control
                                      disabled={true}
                                      defaultValue={card.um}
                                      placeholder="EA"
                                    />
                                  </InputGroup>
                                  {errors?.cards?.[index]?.um && (
                                    <span className="text-danger">
                                    </span>
                                  )}
                                </Form.Group>
                              </Col>

                              <Col className="mob_50">
                                <Form.Group className="lock_group">
                                  <Form.Label className="required">
                                    Aspetto's Cost
                                  </Form.Label>
                                  <InputGroup>
                                    <InputGroup.Text>
                                      <IconCurrencyDollar stroke={2} />
                                    </InputGroup.Text>

                                    <Form.Control
                                      type="text"
                                      onKeyDown={handleKeyDown}
                                      step="any"
                                      defaultValue={card.cost}
                                      placeholder="Enter Cost"
                                      {...register(
                                        `product_sales[${index}].cost`,
                                        {
                                          required: "Cost is required",
                                          pattern: {
                                            value: /^[0-9]+(\.[0-9]{1,2})?$/,
                                            message: "Enter a valid cost",
                                          },
                                        },
                                      )}
                                      disabled={
                                        order_ref_type === "project" ||
                                        !canEditProducts
                                      }
                                      onChange={(e) => {
                                        setValue(
                                          `product_sales[${index}].cost`,
                                          e.target.value,
                                          {
                                            shouldValidate: true,
                                          },
                                        );
                                        recalcSalesRow(index);
                                      }}
                                    />

                                  </InputGroup>
                                  {errors?.cards?.[index]?.cost && (
                                    <span className="text-danger">
                                    </span>
                                  )}
                                  <span className="lock_unlock">
                                    <Form.Check
                                      type="switch" // Using 'switch' for better visual feedback, but you can keep 'checkbox' if preferred
                                      id={`lock-toggle-${index}`}
                                      step="any"
                                      disabled={true}
                                      label={
                                        <>
                                          {watch(`cards[${index}].CostLock`) ? (
                                            <IconLock stroke={1} />
                                          ) : (
                                            <IconLockOpen2 stroke={1} />
                                          )}
                                        </>
                                      }
                                      checked={watch(
                                        `cards[${index}].CostLock`,
                                      )}
                                      onChange={() =>
                                        handleLockChange("CostLock", index)
                                      }
                                    />
                                  </span>
                                </Form.Group>
                              </Col>

                              {showSkuId && (
                                <>
                                  <Col className="small_drag_column mob_50">
                                    <Form.Group className="lock_group">
                                      <Form.Label className="required">
                                        Margin
                                      </Form.Label>
                                      <InputGroup>
                                        <InputGroup.Text>
                                          <IconPercentage stroke={2} />
                                        </InputGroup.Text>

                                        <Form.Control
                                          // onKeyDown={handleKeyDown}
                                          type="text"
                                          step="any"
                                          defaultValue={card.margin}
                                          placeholder="0.00"
                                          disabled={true}
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]?.margin && (
                                        <span className="text-danger">
                                          {errors.cards[index].margin.message}
                                        </span>
                                      )}
                                      <span className="lock_unlock">
                                        <Form.Check
                                          type="switch" // Using 'switch' for better visual feedback, but you can keep 'checkbox' if preferred
                                          id={`margin-lock-toggle-${index}`}
                                          disabled={true}
                                          label={
                                            <>
                                              {watch(
                                                `cards[${index}].marginLock`,
                                              ) ? (
                                                <IconLock stroke={1} />
                                              ) : (
                                                <IconLockOpen2 stroke={1} />
                                              )}
                                            </>
                                          }
                                          checked={watch(
                                            `cards[${index}].marginLock`,
                                          )}
                                          onChange={() =>
                                            handleLockChange(
                                              "marginLock",
                                              index,
                                            )
                                          }
                                        />
                                      </span>
                                    </Form.Group>
                                  </Col>

                                  <Col className="mob_50">
                                    <Form.Group className="lock_group">
                                      <Form.Label>Customer's Cost</Form.Label>
                                      <InputGroup>
                                        <InputGroup.Text>
                                          <IconCurrencyDollar stroke={2} />
                                        </InputGroup.Text>
                                        <Form.Control
                                          type="text"
                                          step="any"
                                          onKeyDown={handleKeyDown}
                                          defaultValue={card.customerCost}
                                          placeholder="Customer's Cost"
                                          disabled={true}
                                          checked={watch(
                                            `cards[${index}].customerCostLock`,
                                          )}
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]?.customerCost && (
                                        <span className="text-danger">
                                        </span>
                                      )}
                                      <span className="lock_unlock">
                                        <Form.Check
                                          type="switch"
                                          id={`customer-cost-lock-toggle-${index}`}
                                          label={
                                            <>
                                              {watch(
                                                `cards[${index}].customerCostLock`,
                                              ) ? (
                                                <IconLock stroke={1} />
                                              ) : (
                                                <IconLockOpen2 stroke={1} />
                                              )}
                                            </>
                                          }
                                          checked={watch(
                                            `cards[${index}].customerCostLock`,
                                          )}
                                          disabled={true}
                                          onChange={() =>
                                            handleLockChange(
                                              "customerCostLock",
                                              index,
                                            )
                                          }
                                        />
                                      </span>
                                    </Form.Group>
                                  </Col>
                                </>
                              )}
                              <Col className="mob_50">
                                <Form.Group>
                                  <Form.Label>Total SKU Cost</Form.Label>
                                  <InputGroup>
                                    <InputGroup.Text>
                                      <IconCurrencyDollar stroke={2} />
                                    </InputGroup.Text>
                                    <Controller
                                      control={control}
                                      name={`product_sales[${index}].purchaseCost`}
                                      defaultValue={card.purchaseCost}
                                      render={({ field }) => (
                                        <Form.Control
                                          {...field}
                                          readOnly
                                          type="text"
                                          step="any"
                                          onKeyDown={handleKeyDown}
                                          disabled={true}
                                          placeholder="Total SKU Cost"
                                        />
                                      )}
                                    />
                                    
                                  </InputGroup>
                                  {errors?.cards?.[index]?.purchaseCost && (
                                    <span className="text-danger">
                                      {errors.cards[index].purchaseCost.message}
                                    </span>
                                  )}
                                </Form.Group>
                              </Col>
                            </div>

                            {cardSearch[index]?.showSuggestions &&
                              (cardSearch[index]?.vendor ||
                                cardSearch[index]?.sku ||
                                cardSearch[index]?.description) &&
                              dataSuggetion?.data?.length > 0 && (
                                <div
                                  className="suggestions_box"
                                  ref={(el) =>
                                    (suggestionBoxRefs.current[index] = el)
                                  }
                                >
                                  <div className="table-responsive">
                                    <Table>
                                      <tbody>
                                        {dataSuggetion.data.map(
                                          (product, idx) => (
                                            <tr
                                              key={idx}
                                              onClick={() =>
                                                handleProductSelect(
                                                  product,
                                                  index,
                                                )
                                              }
                                            >
                                              <td>
                                                {product?.Vendor?.display_name}
                                              </td>
                                              <td>
                                                {product?.sku_display_name}
                                              </td>
                                              <td>
                                                {" "}
                                                {trimText(
                                                  product?.description,
                                                  100,
                                                )}
                                              </td>
                                              <td>{product?.uoi}</td>
                                              <td>${product?.aspetto_price}</td>
                                              <td>
                                                {product?.margin_percent}%
                                              </td>
                                            </tr>
                                          ),
                                        )}
                                      </tbody>
                                    </Table>
                                  </div>
                                  <div className="text-center">
                                    <Button
                                      variant="link"
                                      className="see-all-btn"
                                      onClick={() =>
                                        handleOpenModal(index, "sku")
                                      }
                                    >
                                      See All SKUs <IconArrowNarrowRight />
                                    </Button>
                                  </div>
                                </div>
                              )}
                          </Card.Body>
                        </Card>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      ) : ( */}
        <div className="drag_section">
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="droppable-cards">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {cardFields.map((card, index) => (
                    <Draggable
                      key={card.id}
                      draggableId={`card-${index}`}
                      index={index}
                    >
                      {(provided) => {
                        // const kitName = cards?.[index]?.kit_name;
                        // // const kitStyle = kitName ? kitColorMap[kitName] : null;
                        // const kitStyle =
                        //   kitName && kitColorMap[kitName]
                        //     ? kitColorMap[kitName]
                        //     : null;
                        // const isFirstInKit =
                        //   !!kitStyle &&
                        //   kitName &&
                        //   (cards || []).findIndex(
                        //     (c) => c?.kit_name === kitName,
                        //   ) === index;
                        // const isLastInKit =
                        //   !!kitStyle &&
                        //   kitName &&
                        //   [...(cards || [])]
                        //     .map((c, i) => (c?.kit_name === kitName ? i : -1))
                        //     .filter((i) => i !== -1)
                        //     .pop() === index;

                        const kitKey = cards?.[index]?.kit_raw_sku_id;
                        const kitStyle =
                          kitKey && kitColorMap[kitKey]
                            ? kitColorMap[kitKey]
                            : null;
                        const isFirstInKit =
                          !!kitStyle &&
                          (cards || []).findIndex(
                            (c) => c?.kit_raw_sku_id === kitKey,
                          ) === index;
                        const isLastInKit =
                          !!kitStyle &&
                          [...(cards || [])]
                            .map((c, i) =>
                              c?.kit_raw_sku_id === kitKey ? i : -1,
                            )
                            .filter((i) => i !== -1)
                            .pop() === index;

                        return (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            style={{
                              ...provided.draggableProps.style,
                              ...(kitStyle
                                ? {
                                    background: kitStyle.bg,
                                    borderLeft: `4px solid ${kitStyle.border}`,
                                    borderRight: `1px solid ${kitStyle.border}`,
                                    borderTop: isFirstInKit
                                      ? `1px solid ${kitStyle.border}`
                                      : "none",
                                    borderBottom: isLastInKit
                                      ? `1px solid ${kitStyle.border}`
                                      : "none",
                                    borderRadius: isFirstInKit
                                      ? "6px 6px 0 0"
                                      : isLastInKit
                                        ? "0 0 6px 6px"
                                        : "0",
                                    marginBottom: isLastInKit ? "12px" : "0",
                                  }
                                : {}),
                            }}
                          >
                            {/* {isFirstInKit && (
                              <div
                                style={{
                                  padding: "4px 12px",
                                  fontSize: "11px",
                                  fontWeight: 700,
                                  letterSpacing: "0.5px",
                                  color: kitStyle.border,
                                  textTransform: "uppercase",
                                  borderBottom: `1px dashed ${kitStyle.border}`,
                                }}
                              >
                                KIT: {kitName}
                              </div>
                            )} */}
                            {isFirstInKit && (
                              <div
                                style={{
                                  padding: "4px 12px",
                                  fontSize: "11px",
                                  fontWeight: 700,
                                  letterSpacing: "0.5px",
                                  color: kitStyle.border,
                                  textTransform: "uppercase",
                                  borderBottom: `1px dashed ${kitStyle.border}`,
                                }}
                              >
                                KIT: {kitStyle.name}
                              </div>
                            )}
                            {/* <Card
                              {...provided.dragHandleProps}
                              className={kitStyle ? "" : "mb-3"}
                              style={{
                                border: "none",
                                borderRadius: 0,
                                background: "transparent",
                              }}
                            > */}
                            <Card
                              {...provided.dragHandleProps}
                              className={kitStyle ? "" : "mb-3"}
                              style={
                                kitStyle
                                  ? {
                                      border: "none",
                                      borderRadius: 0,
                                      background: "transparent",
                                    }
                                  : {}
                              }
                            >
                              <Card.Body>
                                <div className="grag_flex_row">
                                  <Col className="mob_50">
                                    <Form.Group>
                                      <Form.Label className="required">
                                        VENDOR'S PARTNER
                                      </Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          {...register(
                                            `cards[${index}].vendorPartner`,
                                          )}
                                          disabled={
                                            order_ref_type === "project" ||
                                            !canEditProducts
                                          }
                                          defaultValue={card.vendorPartner}
                                          placeholder="Enter Name"
                                          // value={cardSearch[activeCardIndex]?.vendor || ""}
                                          onBlur={() => handleBlur(index)}
                                          onChange={handleSearchByName}
                                          // onChange={(e) =>
                                          //   handleSearchChange(
                                          //     activeCardIndex,
                                          //     "vendor",
                                          //     e.target.value
                                          //   )
                                          // }
                                          onFocus={() =>
                                            handleInputFocus(index)
                                          }
                                        />
                                      </InputGroup>
                                      <div>
                                        {index === activeCardIndex &&
                                          suggestionData?.data?.length > 0 &&
                                          searchDebounces?.searchName?.length >
                                            0 && (
                                            <div
                                              className="suggestions_box"
                                              ref={(el) =>
                                                (vendorSuggestionRefs.current[
                                                  index
                                                ] = el)
                                              }
                                            >
                                              <div className="table-responsive">
                                                <Table>
                                                  <tbody>
                                                    {suggestionData?.data?.map(
                                                      (item, idx) => (
                                                        <tr
                                                          key={idx}
                                                          onClick={() =>
                                                            handleSelectVendor(
                                                              item,
                                                              index,
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                        >
                                                          <td>
                                                            {item?.display_name}
                                                          </td>
                                                        </tr>
                                                      ),
                                                    )}
                                                  </tbody>
                                                </Table>
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                      {errors?.cards?.[index]
                                        ?.vendorPartner && (
                                        <span className="text-danger">
                                          {/* {errors.cards[index].vendorPartner.message} */}
                                        </span>
                                      )}
                                    </Form.Group>
                                  </Col>
                                  <div className="mid_drag_column mob_50">
                                    <Form.Group>
                                      <Form.Label className="">
                                        PRODUCT NAME
                                      </Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          disabled={true}
                                          {...register(
                                            `cards[${index}].productName`,
                                          )}
                                          placeholder="Product Name"
                                        />
                                      </InputGroup>
                                    </Form.Group>
                                  </div>
                                  {/* <Col className="mid_drag_column mob_50">
                                    <Form.Group>
                                      <Form.Label className="required">
                                        PRODUCT ID
                                      </Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          {...register(
                                            `cards[${index}].productId`,
                                          )}
                                          placeholder="PRODUCT ID"
                                        />
                                      </InputGroup>
                                    </Form.Group>
                                  </Col> */}
                                  {showSkuId && (
                                    <>
                                      <Col className="mid_drag_column mob_50">
                                        <Form.Group>
                                          <Form.Label className="required">
                                            PRODUCT ID
                                          </Form.Label>
                                          <InputGroup>
                                            <Form.Control
                                              {...register(
                                                `cards[${index}].productId`,
                                              )}
                                              placeholder="PRODUCT ID"
                                            />
                                          </InputGroup>
                                        </Form.Group>
                                      </Col>
                                      <Col className="mid_drag_column mob_50">
                                        <Form.Group>
                                          <Form.Label className="required">
                                            UNIQUE SKU ID
                                          </Form.Label>
                                          <InputGroup>
                                            <Form.Control
                                              {...register(
                                                `cards[${index}].skuIdUnique`,
                                              )}
                                              placeholder="SKU ID"
                                              defaultValue={card.skuIdUnique}
                                              disabled={
                                                order_ref_type === "project"
                                              }
                                            />
                                          </InputGroup>
                                        </Form.Group>
                                      </Col>
                                      <Col className="mid_drag_column mob_50">
                                        <Form.Group>
                                          <Form.Label className="required">
                                            ROW ID
                                          </Form.Label>
                                          <InputGroup>
                                            <Form.Control
                                              {...register(
                                                `cards[${index}].rowId`,
                                              )}
                                              disabled={true}
                                              placeholder="ROW ID"
                                              defaultValue={card.rowId}
                                            />
                                          </InputGroup>
                                        </Form.Group>
                                      </Col>
                                    </>
                                  )}
                                  <Col className="mid_drag_column mob_50">
                                    <Form.Group>
                                      <Form.Label className="required">
                                        SKU ID
                                      </Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          // disabled={order_ref_type === "project"}
                                          disabled={true}
                                          {...register(`cards[${index}].skuId`)}
                                          // value={watch(`cards[${index}].skuId`)}
                                          placeholder="SKU ID"
                                          defaultValue={card.skuId}
                                          onBlur={() => handleBlur(index)}
                                          onChange={(e) =>
                                            handleSearchChange(
                                              activeCardIndex,
                                              "sku",
                                              e.target.value,
                                            )
                                          }
                                          onFocus={() =>
                                            handleInputFocus(index)
                                          }
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]?.skuId && (
                                        <span className="text-danger">
                                          {/* {errors.cards[index].skuId.message} */}
                                        </span>
                                      )}
                                    </Form.Group>
                                  </Col>
                                  <Col className="mob_100">
                                    <Form.Group>
                                      <Form.Label className="">
                                        SKU DESCRIPTION
                                      </Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          as="textarea"
                                          disabled={
                                            order_ref_type === "project" ||
                                            !canEditProducts
                                          }
                                          rows={1} // Adjust the number of visible text lines
                                          {...register(
                                            `cards[${index}].skuDescription`,
                                          )}
                                          defaultValue={card.skuDescription}
                                          placeholder="Description"
                                          ref={(el) => {
                                            textAreaRefs.current[index] = el;
                                          }}
                                          style={{
                                            resize: "none",
                                            overflow: "hidden",
                                          }}
                                          onChange={(e) => {
                                            setValue(
                                              `cards[${index}].skuDescription`,
                                              e.target.value,
                                            );
                                            adjustTextAreaHeight(index); // Resize on input change
                                          }}
                                          // onChange={(e) => {
                                          //   handleSearchChange(
                                          //     index,
                                          //     "description",
                                          //     e.target.value,
                                          //     setValue(
                                          //       `cards[${index}].skuDescription`,
                                          //       e.target.value
                                          //     )
                                          //   );
                                          //   adjustTextAreaHeight(index); // Resize on input change
                                          // }}
                                          // onBlur={() => handleBlur(index)}
                                          // onFocus={() => handleInputFocus(index)}
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]
                                        ?.skuDescription && (
                                        <span className="text-danger">
                                          {/* {errors.cards[index].skuDescription.message} */}
                                        </span>
                                      )}
                                    </Form.Group>
                                  </Col>

                                  <Col className="small_drag_column mob_50">
                                    <Form.Group>
                                      <Form.Label className="required">
                                        QTY
                                      </Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          type="text"
                                          onKeyDown={handleKeyDown}
                                          {...register(`cards[${index}].qty`, {
                                            required: "Quantity is required",
                                            // pattern: {
                                            //   value: /^[0-9]+$/,
                                            //   message:
                                            //     "Quantity must be a number",
                                            // },
                                            pattern: {
                                              value: /^[0-9]*\.?[0-9]+$/,
                                              message:
                                                "Quantity must be a valid number",
                                            },
                                          })}
                                          defaultValue={card.qty}
                                          placeholder="0"
                                          disabled={true}
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]?.qty && (
                                        <span className="text-danger">
                                          {/* {errors.cards[index].qty.message} */}
                                        </span>
                                      )}
                                    </Form.Group>
                                  </Col>

                                  <Col className="small_drag_column mob_50">
                                    <Form.Group>
                                      <Form.Label>UM</Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          {...register(`cards[${index}].um`)}
                                          // disabled={order_ref_type === "project"}
                                          disabled={true}
                                          defaultValue={card.um}
                                          placeholder="EA"
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]?.um && (
                                        <span className="text-danger">
                                          {/* {errors.cards[index].qty.message} */}
                                        </span>
                                      )}
                                    </Form.Group>
                                  </Col>

                                  <Col className="mob_50">
                                    <Form.Group className="lock_group">
                                      <Form.Label className="required">
                                        Aspetto's Cost
                                      </Form.Label>
                                      <InputGroup>
                                        <InputGroup.Text>
                                          <IconCurrencyDollar stroke={2} />
                                        </InputGroup.Text>

                                        <Form.Control
                                          type="text"
                                          onKeyDown={handleKeyDown}
                                          step="any"
                                          {...register(`cards[${index}].cost`, {
                                            required: "Cost is required",
                                            pattern: {
                                              value: /^[0-9]+(\.[0-9]{1,2})?$/,
                                              message: "Enter a valid cost",
                                            },
                                          })}
                                          defaultValue={card.cost}
                                          placeholder="Enter Cost"
                                          // disabled={watch(`cards[${index}].CostLock`)}
                                          disabled={
                                            watch(`cards[${index}].CostLock`) ||
                                            order_ref_type === "project" ||
                                            !canEditProducts
                                          }
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]?.cost && (
                                        <span className="text-danger">
                                          {/* {errors.cards[index].cost.message} */}
                                        </span>
                                      )}
                                      <span className="lock_unlock">
                                        <Form.Check
                                          type="switch" // Using 'switch' for better visual feedback, but you can keep 'checkbox' if preferred
                                          id={`lock-toggle-${index}`}
                                          step="any"
                                          label={
                                            <>
                                              {watch(
                                                `cards[${index}].CostLock`,
                                              ) ? (
                                                <IconLock stroke={1} />
                                              ) : (
                                                <IconLockOpen2 stroke={1} />
                                              )}
                                            </>
                                          }
                                          {...register(
                                            `cards[${index}].CostLock`,
                                          )}
                                          checked={watch(
                                            `cards[${index}].CostLock`,
                                          )}
                                          onChange={() =>
                                            handleLockChange("CostLock", index)
                                          }
                                        />
                                      </span>
                                    </Form.Group>
                                  </Col>

                                  {/* {showSkuId && ( */}
                                  <Col className="small_drag_column mob_50 d-none">
                                    <Form.Group className="lock_group">
                                      <Form.Label className="required">
                                        Margin
                                      </Form.Label>
                                      <InputGroup>
                                        <InputGroup.Text>
                                          <IconPercentage stroke={2} />
                                        </InputGroup.Text>

                                        <Form.Control
                                          onKeyDown={handleKeyDown}
                                          type="text"
                                          step="any"
                                          {...register(
                                            `cards[${index}].margin`,
                                            {
                                              required: "Margin is required",
                                            },
                                          )}
                                          defaultValue={card.margin}
                                          placeholder="0.00"
                                          disabled={
                                            watch(
                                              `cards[${index}].marginLock`,
                                            ) || order_ref_type === "project"
                                          }
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]?.margin && (
                                        <span className="text-danger">
                                          {errors.cards[index].margin.message}
                                        </span>
                                      )}
                                      <span className="lock_unlock">
                                        <Form.Check
                                          type="switch" // Using 'switch' for better visual feedback, but you can keep 'checkbox' if preferred
                                          id={`margin-lock-toggle-${index}`}
                                          label={
                                            <>
                                              {watch(
                                                `cards[${index}].marginLock`,
                                              ) ? (
                                                <IconLock stroke={1} />
                                              ) : (
                                                <IconLockOpen2 stroke={1} />
                                              )}
                                            </>
                                          }
                                          {...register(
                                            `cards[${index}].marginLock`,
                                          )}
                                          checked={watch(
                                            `cards[${index}].marginLock`,
                                          )}
                                          onChange={() =>
                                            handleLockChange(
                                              "marginLock",
                                              index,
                                            )
                                          }
                                        />
                                      </span>
                                    </Form.Group>
                                  </Col>
                                  {/* )} */}
                                  {/* {showSkuId && ( */}
                                  <Col className="mob_50 d-none">
                                    <Form.Group className="lock_group">
                                      <Form.Label>Customer's Cost</Form.Label>
                                      <InputGroup>
                                        <InputGroup.Text>
                                          <IconCurrencyDollar stroke={2} />
                                        </InputGroup.Text>
                                        <Form.Control
                                          type="text"
                                          step="any"
                                          onKeyDown={handleKeyDown}
                                          {...register(
                                            `cards[${index}].customerCost`,
                                            {
                                              required:
                                                "Customer's cost is required",
                                              pattern: {
                                                value:
                                                  /^[0-9]+(\.[0-9]{1,2})?$/,
                                                message:
                                                  "Enter a valid customer cost",
                                              },
                                            },
                                          )}
                                          defaultValue={card.customerCost}
                                          placeholder="Customer's Cost"
                                          disabled={
                                            watch(
                                              `cards[${index}].customerCostLock`,
                                            ) || order_ref_type === "project"
                                          }
                                          checked={watch(
                                            `cards[${index}].customerCostLock`,
                                          )}
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]?.customerCost && (
                                        <span className="text-danger">
                                          {/* {errors.cards[index].customerCost.message} */}
                                        </span>
                                      )}
                                      <span className="lock_unlock">
                                        <Form.Check
                                          type="switch"
                                          id={`customer-cost-lock-toggle-${index}`}
                                          label={
                                            <>
                                              {watch(
                                                `cards[${index}].customerCostLock`,
                                              ) ? (
                                                <IconLock stroke={1} />
                                              ) : (
                                                <IconLockOpen2 stroke={1} />
                                              )}
                                            </>
                                          }
                                          {...register(
                                            `cards[${index}].customerCostLock`,
                                          )}
                                          checked={watch(
                                            `cards[${index}].customerCostLock`,
                                          )}
                                          onChange={() =>
                                            handleLockChange(
                                              "customerCostLock",
                                              index,
                                            )
                                          }
                                        />
                                      </span>
                                    </Form.Group>
                                  </Col>
                                  {/* )} */}
                                  <Col className="mob_50">
                                    <Form.Group>
                                      <Form.Label>Total SKU Cost</Form.Label>
                                      <InputGroup>
                                        <InputGroup.Text>
                                          <IconCurrencyDollar stroke={2} />
                                        </InputGroup.Text>
                                        <Form.Control
                                          readOnly
                                          type="text"
                                          onKeyDown={handleKeyDown}
                                          {...register(
                                            `cards[${index}].totalSkuCost`,
                                            {
                                              required:
                                                "Total SKU cost is required",
                                              pattern: {
                                                value:
                                                  /^[0-9]+(\.[0-9]{1,2})?$/,
                                                message:
                                                  "Enter a valid total SKU cost",
                                              },
                                            },
                                          )}
                                          defaultValue={card.totalSkuCost}
                                          disabled={
                                            order_ref_type === "project"
                                          }
                                          placeholder="Total SKU Cost"
                                        />
                                      </InputGroup>
                                      {errors?.cards?.[index]?.totalSkuCost && (
                                        <span className="text-danger">
                                          {
                                            errors.cards[index].totalSkuCost
                                              .message
                                          }
                                        </span>
                                      )}
                                    </Form.Group>
                                  </Col>
                                </div>

                                <div className="text-danger text-start mt-2">
                                  {vendorWarnings[index] && (
                                    <div>
                                      This name does not match the master
                                      vendor. If it’s intentional, hit next to
                                      proceed.
                                    </div>
                                  )}
                                </div>

                                {cardSearch[index]?.showSuggestions &&
                                  (cardSearch[index]?.vendor ||
                                    cardSearch[index]?.sku ||
                                    cardSearch[index]?.description) &&
                                  dataSuggetion?.data?.length > 0 && (
                                    <div className="suggestions_box">
                                      <div className="table-responsive">
                                        <Table>
                                          <tbody>
                                            {dataSuggetion.data.map(
                                              (product, idx) => (
                                                <tr
                                                  key={idx}
                                                  onClick={() =>
                                                    handleProductSelect(
                                                      product,
                                                      index,
                                                    )
                                                  }
                                                >
                                                  <td>
                                                    {
                                                      product?.Vendor
                                                        ?.display_name
                                                    }
                                                  </td>
                                                  <td>
                                                    {product?.sku_display_name}
                                                  </td>
                                                  <td>
                                                    {" "}
                                                    {trimText(
                                                      product?.description,
                                                      100,
                                                    )}
                                                  </td>
                                                  <td>{product?.uoi}</td>
                                                  <td>
                                                    ${product?.aspetto_price}
                                                  </td>
                                                  <td>
                                                    {product?.margin_percent}%
                                                  </td>
                                                </tr>
                                              ),
                                            )}
                                          </tbody>
                                        </Table>
                                      </div>
                                      <div className="text-center">
                                        <Button
                                          variant="link"
                                          className="see-all-btn"
                                          onClick={() =>
                                            handleOpenModal(index, "sku")
                                          }
                                        >
                                          See All SKUs <IconArrowNarrowRight />
                                        </Button>
                                      </div>
                                    </div>
                                  )}
                              </Card.Body>
                            </Card>
                          </div>
                        );
                      }}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>

            {/* {order_ref_type === "project" ? null : ( */}
            {/* <div className="add_remove_sku mb-3">
              <p className="text-center mb-2">Product Items (SKUs)</p>
              <div className="btn_group_sku">
                <Button
                  variant=""
                  className="add_sku_button"
                  onClick={handleAddCard}
                >
                  <IconPlus /> BLANK PRODUCT
                </Button>
                <Button
                  variant=""
                  className="add_sku_button"
                  onClick={() => handleOpenModal(null, "skuAll")}
                >
                  <IconSearch /> PRODUCTS LIBRARY
                </Button>
                <Button
                  variant=""
                  className="add_sku_button"
                  onClick={handleCopySalesProductsToCards}
                >
                  <IconCopy /> FILL FROM PRODUCTS (SALES)
                </Button>
                <Button
                variant=""
                className="add_sku_button"
                onClick={() => handleOpenModal(null, "contract")}

              >
                <IconSearch /> BROWSE BY CONTRACT VEHICLE
              </Button>
              </div>
            </div> */}
            {/* ) */}

            {/* } */}
          </DragDropContext>
        </div>
      {/* // )} */}
      {/* {OrderTypes === "M" ||
      OrderTypes === "CRK" ||
      OrderTypes === "DS" ||
      OrderTypes === "S" ? (
        <div>
          <Card.Body>
            <Row></Row>
            <Row className={`mb-2 ${shippingHide ? "d-none" : ""}`}>

              <div className="costing_rows p-0">
                <Form.Check
                  className="ps-0 pe-2"
                  type="switch"
                  label="Shipping Cost"
                  {...register("shippingCostEnabled")}
                  disabled={order_ref_type === "project"}
                  checked={getValues("shippingCostEnabled")}
                  onChange={(e) =>
                    setValue("shippingCostEnabled", e.target.checked)
                  }
                />

                <div className="costing_input">
                  <Form.Group>
                    <InputGroup>
                      <InputGroup.Text>
                        <IconCurrencyDollar stroke={2} />
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        step="any"
                        onKeyDown={handleKeyDown}
                        value={shippingCostPurchase}
                        // {...register("shippingCost", {
                        //   required: watch("shippingCostEnabled")
                        //     ? "Shipping cost is required"
                        //     : false,
                        //   // pattern: {
                        //   //   value: /^[0-9]+(\.[0-9]{1,2})?$/,
                        //   //   message: "Enter a valid shipping cost",
                        //   // },
                        // })}
                        disabled={true}
                      />
                    </InputGroup>
                  </Form.Group>
                </div>
              </div>
            </Row>

            <Row className="mb-2">
              <div className="costing_rows p-0">
                <Form.Check
                  className="ps-0 pe-2"
                  type="switch"
                  label="Tax"
                  {...register("taxEnabled")}
                  checked={getValues("taxEnabled")}
                  onChange={(e) => setValue("taxEnabled", e.target.checked)}
                />

                <div className="costing_input">
                  <Form.Group>
                    <InputGroup>
                      <InputGroup.Text>
                        <IconCurrencyDollar />
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        step="any"
                        // defaultValue={0.00}
                        value={taxsales}
                        onKeyDown={handleKeyDown}
                        // {...register("tax", {
                        //   required: watch("taxEnabled")
                        //     ? "Tax is required"
                        //     : false,
                        //   // pattern: {
                        //   //   value: /^[0-9]+(\.[0-9]{1,2})?$/,
                        //   //   message: "Enter a valid tax amount",
                        //   // },
                        // })}
                        placeholder="0.00"
                        disabled={true}
                      />
                    </InputGroup>
                  </Form.Group>
                </div>
              </div>
            </Row>

            <Row className="mb-2 justify-content-end">
              {duplicateValues?.map((item, index) => (
                <Row className="mb-2" key={item.id}>
                  <div className="costing_rows p-0">
                    <div className="costing_input">
                      <span
                        className="trash_icon"
                        onClick={() => handleRemoveOthercost(index)}
                      >
                        <IconTrash />
                      </span>
                      <Form.Group>
                        <InputGroup className="costing_name">
                          <Form.Control
                            {...register(
                              `other_cost_json_sales[${index}].Name`,
                            )}
                            placeholder="Enter Cost Name"
                            disabled={true}
                          />
                        </InputGroup>
                        {errors?.otherCost?.[index]?.Name && (
                          <span className="text-danger">
                          </span>
                        )}
                      </Form.Group>

                      <Form.Group>
                        <InputGroup className="costing_amount">
                          <InputGroup.Text>
                            <IconCurrencyDollar />
                          </InputGroup.Text>
                          <Form.Control
                            type="number"
                            step="any"
                            {...register(
                              `other_cost_json_sales[${index}].Amount`,
                              {
                                required: "Amount is required",
                                pattern: {
                                  value: /^[0-9]+(\.[0-9]{1,2})?$/,
                                  message: "Enter a valid amount",
                                },
                              },
                            )}
                            placeholder="Amount"
                            disabled={true}
                          />
                        </InputGroup>

                        {errors?.otherCost?.[index]?.Amount && (
                          <span className="text-danger">
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>
                </Row>
              ))}

              {order_ref_type === "project" ? null : (
                <div className="costing_rows p-0">
                  <Button
                    variant=""
                    className="add_sku_button w-auto"
                    onClick={handleAddOtherCost}
                    disabled={true}
                  >
                    <IconPlus /> OTHER COST
                  </Button>
                </div>
              )}
            </Row>

            <div className="totle_costing mt-3">
              <h6>
                Total Cost:{" "}
                <span>
                  <IconCurrencyDollar />
                  {totalCostBeforeMarginPurchase}
                </span>
              </h6>

              <Form.Control
                // {...register("totalCostBeforeMargin")}
                // value={totalCostBeforeMarginPurchase}
                readOnly
                type="hidden"
                placeholder="Total Cost"
              />
            </div>

            <div className="totle_costing align-items-center justify-content-center gap-5">

              <Form.Control
                // {...register("totalCostAfterMargin")}
                // value={totalCostAfterMargin}
                readOnly
                type="hidden"
                placeholder="Total Price"
              />
            </div>
          </Card.Body>
        </div>
      ) : ( */}
        <div>
          <Card.Body>
            <Row></Row>
            <Row className={`mb-2 ${shippingHide ? "d-none" : ""}`}>
              <div className="d-flex align-items-center gap-2 costing_rows mb-2">
                <Form.Check
                  aria-label="option 1"
                  className="d-flex align-items-center"
                  disabled={!canEditProducts}
                />
                <Form.Check.Label>
                  Do not reduce project total budget
                </Form.Check.Label>
              </div>

              <div className="costing_rows p-0">
                <Form.Check
                  className="ps-0 pe-2"
                  type="switch"
                  label="Shipping Cost (Paid by Aspetto)"
                  {...register("shippingCostEnabled")}
                  disabled={order_ref_type === "project"}
                  checked={getValues("shippingCostEnabled")}
                  onChange={(e) =>
                    setValue("shippingCostEnabled", e.target.checked)
                  }
                />

                <div className="costing_input">
                  <Form.Group>
                    <InputGroup>
                      <InputGroup.Text>
                        <IconCurrencyDollar stroke={2} />
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        step="any"
                        onKeyDown={handleKeyDown}
                        {...register("shippingCost", {
                          required: watch("shippingCostEnabled")
                            ? "Shipping cost is required"
                            : false,
                          // pattern: {
                          //   value: /^[0-9]+(\.[0-9]{1,2})?$/,
                          //   message: "Enter a valid shipping cost",
                          // },
                        })}
                        disabled={
                          !watch("shippingCostEnabled") ||
                          order_ref_type === "project" ||
                          !canEditProducts
                        }
                      />
                    </InputGroup>
                  </Form.Group>
                </div>
              </div>
            </Row>

            <Row className="mb-2">
              <div className="costing_rows p-0">
                <Form.Check
                  className="ps-0 pe-2"
                  type="switch"
                  label="Tax"
                  {...register("taxEnabled")}
                  checked={getValues("taxEnabled")}
                  onChange={(e) => setValue("taxEnabled", e.target.checked)}
                />

                <div className="costing_input">
                  <Form.Group>
                    <InputGroup>
                      <InputGroup.Text>
                        <IconCurrencyDollar />
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        step="any"
                        // defaultValue={0.00}
                        onKeyDown={handleKeyDown}
                        {...register("tax", {
                          required: watch("taxEnabled")
                            ? "Tax is required"
                            : false,
                          // pattern: {
                          //   value: /^[0-9]+(\.[0-9]{1,2})?$/,
                          //   message: "Enter a valid tax amount",
                          // },
                        })}
                        placeholder="0.00"
                        disabled={
                          !watch("taxEnabled") ||
                          order_ref_type === "project" ||
                          !canEditProducts
                        }
                      />
                    </InputGroup>
                  </Form.Group>
                </div>
              </div>
            </Row>

            <Row className="mb-2 justify-content-end">
              {otherCostFields.map((item, index) => (
                <Row className="mb-2" key={item.id}>
                  <div className="costing_rows p-0">
                    <div className="costing_input">
                      <span
                        className="trash_icon"
                        onClick={() => handleRemoveOthercost(index)}
                      >
                        <IconTrash />
                      </span>
                      <Form.Group>
                        <InputGroup className="costing_name">
                          <Form.Control
                            {...register(`otherCost[${index}].Name`)}
                            placeholder="Enter Cost Name"
                            disabled={order_ref_type === "project"}
                          />
                        </InputGroup>
                        {errors?.otherCost?.[index]?.Name && (
                          <span className="text-danger">
                          </span>
                        )}
                      </Form.Group>

                      <Form.Group>
                        <InputGroup className="costing_amount">
                          <InputGroup.Text>
                            <IconCurrencyDollar />
                          </InputGroup.Text>
                          <Form.Control
                            type="number"
                            {...register(`otherCost[${index}].Amount`, {
                              required: "Amount is required",
                              pattern: {
                                value: /^[0-9]+(\.[0-9]{1,2})?$/,
                                message: "Enter a valid amount",
                              },
                            })}
                            placeholder="Amount"
                            disabled={order_ref_type === "project"}
                          />
                        </InputGroup>

                        {errors?.otherCost?.[index]?.Amount && (
                          <span className="text-danger">
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>
                </Row>
              ))}

              {order_ref_type === "project" ? null : (
                <div className="costing_rows p-0">
                  <Button
                    variant=""
                    className="add_sku_button w-auto"
                    onClick={handleAddOtherCost}
                    disabled={order_ref_type === "project" || !canEditProducts}
                  >
                    <IconPlus /> OTHER COST
                  </Button>
                </div>
              )}
            </Row>

            <div className="totle_costing mt-3">
              <h6>
                Total Cost:{" "}
                <span>
                  <IconCurrencyDollar />
                  {totalCostBeforeMargin}
                </span>
              </h6>

              <Form.Control
                {...register("totalCostBeforeMargin")}
                value={totalCostBeforeMargin}
                readOnly
                type="hidden"
                placeholder="Total Cost Before Margin"
              />
            </div>

            <div className="totle_costing align-items-center justify-content-center gap-5">
              {/* {roundToMoney(totalCostBeforeMargin) !==
                roundToMoney(totalCostBeforeMarginPurchase) && (
                <div
                  class="invalid-feedback d-block w-auto mt-0"
                  style={{ fontSize: "15px" }}
                >
                  Total cost of Sales and Purchase Tabs do not match. Please review the
                  entered info.
                </div>
              )} */}
              {/* <h6>
                Total Price:{" "}
                <span>
                  <IconCurrencyDollar />
                  {totalCostAfterMargin}
                </span>
              </h6> */}

              <Form.Control
                {...register("totalCostAfterMargin")}
                value={totalCostAfterMargin}
                readOnly
                type="hidden"
                placeholder="Total Price"
              />
            </div>
          </Card.Body>
        </div>
      {/* // )} */}
    </>
  );
}

export default OrderDetailsForm;
